import { useCurrentUser } from '@/hooks/useCurrentUser';
import logo from '@/assets/icons/main_logo.svg';
import { SidebarNav } from './SidebarNav';
import { SidebarProfileMenu } from './SidebarProfileMenu';
import { ADMIN_NAV, CONSULTANT_NAV } from './sidebar-nav-config';

export function Sidebar() {
  const { user, isAdmin } = useCurrentUser();
  const currentView: 'admin' | 'consultant' = isAdmin ? 'admin' : 'consultant';

  const sections = currentView === 'admin' ? ADMIN_NAV : CONSULTANT_NAV;
  const subtitle = currentView === 'admin' ? 'Admin Console' : 'Platform';

  return (
    <aside
      data-testid="sidebar"
      data-view={currentView}
      className="flex h-screen w-[236px] flex-col border-r bg-sidebar text-sidebar-foreground"
    >
      <div className="flex items-center gap-2 px-5 py-5">
        <img src={logo} alt="" className="h-6 w-auto" />
      </div>

      <div className="flex-1 overflow-y-auto">
        <SidebarNav sections={sections} />
      </div>

      {user && (
        <div className="space-y-2 p-3">
          <SidebarProfileMenu user={user} />
        </div>
      )}
    </aside>
  );
}
